module.exports = __webpack_public_path__ + "assets/1a686615736a0eb8ce5efa461af45afd.png";